document.addEventListener("DOMContentLoaded", () => {
    const search = document.getElementById("search");

    if (!search) {
        return;
    }

    const specialNeedsInputAll = search.querySelectorAll(
        ".special-needs input",
    );
    const specialNeedsTypesWrappers = search.querySelectorAll(
        ".special-needs-types",
    );

    specialNeedsInputAll.forEach(function (specialNeedsInput) {
        specialNeedsInput.addEventListener("change", (event) => {
            if (specialNeedsInput.checked) {
                specialNeedsTypesWrappers.forEach(function (specialNeedsTypes) {
                    specialNeedsTypes.classList.remove("d-none");
                });

                return;
            }

            specialNeedsTypesWrappers.forEach(function (specialNeedsTypes) {
                specialNeedsTypes.classList.add("d-none");
            });
        });
    });
});
